import { SERVICEURI } from "../const/serviceuri";
import { getFromBlob, getFrameworkApiInstance } from '../instance/fetchframeworkapiInstance';
import { IsEmpty } from "../utils/string";


const getTransalationByUserId = (userid:any): Promise<any> => {

    let userId = userid;
    let endPoint = SERVICEURI.GetTransalationByUser.replace("{userid}", userId);

    if (IsEmpty(userId)) {
        return Promise.resolve(GetFromBlobOnfailure());
    }
    else {
        return new Promise((onSucess, onFailure) => {
            getFrameworkApiInstance(endPoint).then(response => {
                onSucess(response);
            }).catch((error: any) => {
                onSucess(GetFromBlobOnfailure());
            });
        });
    }
};

const GetFromBlobOnfailure = (): Promise<any> => {
    return new Promise((onSucess, onFailure) => {
         getFromBlob("", "Translation")
            .then(response => {
                onSucess(response);
            })
            .catch((error: any) => {
                onFailure(error);
            });
    });
}

export default
    {
        getTransalationByUserId
    }